import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import { deleteChannel } from '../../services'

interface UseMutationDeleteChannelProps {
	id: string
}

export default function useMutationDeleteChannel(
	props?: UseBaseMutationOptions<void, UseMutationDeleteChannelProps>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.DeleteChannel],
		mutationFn: ({ id }) => deleteChannel(id),
		...props,
	})
}
